'use client'

import { RemotePattern } from 'next/dist/shared/lib/image-config'
import { FunctionComponent } from 'react'
import ReactDOM from 'react-dom'
import { remotePatterns } from '../../config/images.config'
import { PageDto } from '../../types/page.types'

interface Props {
  pageDto: PageDto
}

const defaultUrls = [
  ...remotePatterns.map((remotePattern: RemotePattern) => `${remotePattern?.protocol || 'https'}://${remotePattern.hostname}`),
  'https://mq16w1ud.apicdn.sanity.io',
  'https://shopify-gtm-suite.getelevar.com',
  'https://hits.getelevar.com',
]

const PreConnect: FunctionComponent<Props> = ({ pageDto }) => {
  const urls = [...defaultUrls, `https://${pageDto.shopifyInstance.domain}`]

  // Do not pre-connect when page is part of another window, e.g.
  // when in Sanity Presentation, since it gives errors.
  if (typeof window !== 'undefined' && window !== window?.parent) {
    return null
  }

  urls.forEach((url) => ReactDOM.preconnect(url))

  return null
}

export default PreConnect
